<template>
    <div>
        <div v-for="notification of shown_notifications" v-html="notification.body" class="warning"></div>

        <div class="filter-reservation">

            <div class="left" style="margin-right: 20px;">
                <strong>Boekingsdatum</strong>
                <div class="form-group form-border flatpickr">
                    <div class="group-append h-padding" data-toggle="">
                        <button class="btn btn-link"><i class="icon icon-calendar"></i></button>
                    </div>

                    <div class="group-column">
                        <flat-pickr v-model="date" :config="flat_config" class="form-control form-block" id="picker" ref="datePicker"></flat-pickr>
                    </div>
                </div>
            </div>
        </div>

        <div class="nested">
            <div class="col-lg-66 col-padding">
                <div class="reservation-map">
                    <div id="map"></div>
                </div>
            </div>

            <div class="col-lg-33 col-padding">
                <div class="legend" v-show="selectedLocations.length === 0">
                    <img src="frontend/img/maps/legend.png?v=2024" alt="Legenda">
                </div>

                <div class="reservation-sidebar">
                    <ul class="list" data-toggle="parent">

                        <li v-for="location of selectedLocations" class="active">
                            <div class="col-padding-xs title" style="cursor: pointer" @click="openCard($event)">
                                {{ location.title }} <i class="icon icon-chevron-right"></i>
                            </div>
                            <div class="col-padding-xs desc" data-toggle="text">
                                <img :src="location.image" alt="">

                                <div class="icons">
                                    <ul class="list-inline">
                                        <li>
                                            <img src="frontend/img/content/wifi.svg" alt="WiFi">
                                        </li>
                                        <li v-if="location.max_person > 0">
                                            <img :src="'frontend/img/content/personen'+location.max_person+'.svg'" alt="Aantal personen">
                                        </li>
                                        <li v-if="location.has_tent === '1'">
                                            <img src="frontend/img/content/tent.svg" alt="Stroom (6 ampère) ">
                                        </li>
                                        <li v-if="location.has_power === '1'">
                                            <img src="frontend/img/content/stroom.svg" alt="Stroom (6 ampère) ">
                                        </li>
                                        <li>
                                            <img src="frontend/img/content/hond.svg" alt="Hond">
                                        </li>
                                    </ul>
                                </div>

                                <div style="padding: 20px;">
                                    <div class="description" v-html="location.body"></div>

                                    <div class="bg-brown">v.a. <strong>&euro;{{location.prices.price_from}}</strong> (per overnachting)</div>
                                    <a class="btn btn-block btn-primary" nohref @click="makeReservation">Reserveren</a>

                                    <div class="select-more">
                                        <a nohref @click="can_select = true" style="cursor: pointer">Selecteer nog een plek</a>
                                    </div>

                                    <div class="warning-text">
                                        <p><strong>Let op:</strong> u geeft aan ons een voorkeur door. Het is (nog) niet definitief dat u deze plek(ken) toegewezen krijgt.</p>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from "../event-bus";
    import {Dutch} from '../nl.js';

    export default {
        name: "ReservationMapComponent",
        data() {
            return {
                map: null,
                locations: [],
                can_select: true,
                last_selected: null,
                markers: [],
                selectedLocations: [],
                flat_config: {
                    altFormat: "F j, Y",
                    dateFormat: "d-m-Y",
                    altInput: true,
                    mode: "range",
                    minDate: "today",
                    locale: Dutch,
                    disable: [],
                    onMonthChange: this.flatDisabledDays,
                    onOpen: this.flatDisabledDays,
                    onYearChange: this.flatDisabledDays,
                    onChange: this.flatDisabledDays
                },
                date: null,
                startDate: null,
                endDate: null,
                dates: null,
                dayCount: null,
                notifications: [],
                shown_notifications: [],
                icons: null,
                isAdminUser: false,
				debug: false,
            }
        },
		props: {
			setLocationDate: String,
		},
        watch: {
            date() {
            	// Reset the selected locations
            	this.selectedLocations = [];

                if (this.date.includes("tot")) {
                    // The date is a range so check the full range
                    let startDateSplit = this.date.split(" ")[0].split("-");
                    let endDateSplit = this.date.split(" ")[2].split("-");

                    this.startDate = new Date(startDateSplit[2], (startDateSplit[1] - 1), startDateSplit[0]);
                    this.endDate = new Date(endDateSplit[2], (endDateSplit[1] - 1), endDateSplit[0]);

                    // Now for each notification check if the ranges overlap
                    this.checkNotification(this.startDate, this.endDate);

					// Calculate dayCount used for prices
					let diffTime = this.endDate.getTime() - this.startDate.getTime() ;
					this.dayCount = diffTime / (1000 * 3600 * 24);
                } else {
                    // The date is not a range so only check for the first date
                    let startDateSplit = this.date.split("-");
                    let startDate = new Date(startDateSplit[2], (startDateSplit[1] - 1), startDateSplit[0]);

                    // Now for each notification check if the date falls within the notifications range
                    this.checkNotification(startDate, null);
                }

                let url = false;

                if (this.date.split(" ")[2] !== undefined && this.date.split(" ")[2] !== null) {
                    url = "ajax/get-locations?start=" + this.date.split(" ")[0] + "&end=" + this.date.split(" ")[2];
                }

                if (url !== false) {
                    axios.get(url)
                        .then(response => {
                            for (let i = 0; i < this.markers.length; i++) {
                                this.markers[i].setMap(null);
                            }

                            this.markers = []; //all markers should be removed from array and then the loaded markers should be inserted
                            this.locations = response.data;

                            for (let i = 0; i < this.locations.length; i++) {
                                let location = this.locations[i];

                                location.is_selected = false;
                                const myLatLng = {
                                    lat: parseFloat(location.marker_x),
                                    lng: parseFloat(location.marker_y)
                                };
                                let marker = new google.maps.Marker({
                                    title: String(i),
                                    position: myLatLng,
                                    map: this.map,
                                    icon: location.marker,
                                    label: {
                                        color: '#ffffff',
                                        text: String(location.location_number)
                                    }
                                });

                                // Only available locations should be able to open
                                if (location.available) {
                                    marker.addListener("click", () => {
                                        this.markerClicked(parseInt(marker.getTitle()));
                                    });
                                }

                                this.markers[location.index_id] = marker;
                            }
                        })
                        .catch(e => {
                            this.$swal("Oeps!", "Er is iets mis gegaan bij het laden van de beschikbare locaties. Probeer het later opnieuw.", "error");
                        });
                }

                for (let marker of this.markers) {
                    marker.addListener("click", () => {
                        this.markerClicked(parseInt(marker.getTitle()));
                    });
                }
            },
            can_select() {
                if (this.can_select === true) {
                    let liList = document.getElementsByTagName("li");

                    Array.from(liList).forEach((el) => {
                        el.classList.remove('active');
                    });
                }
            }
        },
        methods: {
            checkNotification(startDate, endDate) {
                this.shown_notifications = [];
                for (let notification of this.notifications) {
                    let notificationStartDateSplit = notification.date_start.split("-");
                    let notificationEndDateSplit = notification.date_end.split("-");

                    let notificationStartDate = new Date(notificationStartDateSplit[0], (notificationStartDateSplit[1] - 1), notificationStartDateSplit[2]);
                    let notificationEndDate = new Date(notificationEndDateSplit[0], (notificationEndDateSplit[1] - 1), notificationEndDateSplit[2]);

                    if (endDate instanceof Date) {
                        if (startDate <= notificationEndDate && endDate >= notificationStartDate) {
                            // The dates overlap so add this notification to the shown notifications array
                            this.shown_notifications.push(notification);
                        }
                    } else {
                        // Only a start date has been passed
                        if (startDate >= notificationStartDate && startDate <= notificationEndDate) {
                            // The date falls within the timeframe
                            this.shown_notifications.push(notification);
                        }
                    }
                }
            },
            openCard(event) {
                // This method is to prevent a weird bug with the opening of cards
                // Without this sometimes the card wouldn't open
                let classList = event.target.parentNode.classList;
                if (classList.contains("active")) {
                    classList.remove("active");
                    event.target.childNodes[1].classList.remove("icon-chevron-down");
                    event.target.childNodes[1].classList.add("icon-chevron-right");
                } else {
                    classList.add("active");
                    event.target.childNodes[1].classList.remove("icon-chevron-right");
                    event.target.childNodes[1].classList.add("icon-chevron-down");
                }
            },
            getNormalizedCoord(coord, zoom) {
                const y = coord.y;
                let x = coord.x; // tile range in one direction range is dependent on zoom level
                // 0 = 1 tile, 1 = 2 tiles, 2 = 4 tiles, 3 = 8 tiles, etc

                const tileRange = 1 << zoom; // don't repeat across y-axis (vertically)

                if (y < 0 || y >= tileRange) {
                    return null;
                } // repeat across x-axis

                if (x < 0 || x >= tileRange) {
                    x = ((x % tileRange) + tileRange) % tileRange;
                }

                return {
                    x: x,
                    y: y,
                };
            },
            initMap() {
                let normFunc = this.getNormalizedCoord;
                const map = new google.maps.Map(document.getElementById("map"), {
                    center: {
                        lat: 0,
                        lng: 0,
                    },
                    zoom: 1,
                    streetViewControl: false,
                    mapTypeControlOptions: {
                        mapTypeIds: ["ballasthoeve"],
                    },
                });
                this.map = map;
                const MapType = new google.maps.ImageMapType({
                    getTileUrl: function (coord, zoom) {
                        const normalizedCoord = normFunc(coord, zoom);

                        if (!normalizedCoord) {
                            return "";
                        }

                        const bound = Math.pow(2, zoom);
                        return (
                            "frontend/img/maps/crops/zoom_" +
                            zoom +
                            "/x" +
                            normalizedCoord.x +
                            "/y" +
                            (bound - normalizedCoord.y - 1) +
                            ".jpeg?v=2023"
                        );
                    },
                    tileSize: new google.maps.Size(256, 256),
                    defaultZoom: 2,
                    maxZoom: 4,
                    minZoom: 2,
                    radius: 1738000,
                    name: "Ballasthoeve",
                });
                map.mapTypes.set("ballasthoeve", MapType);
                map.setMapTypeId("ballasthoeve");
            },
            markerClicked(index) {

                // The last selected location should be false again because selection changed
                if (!this.can_select) {
                    let changeValue = this.locations[this.last_selected];
                    changeValue.is_selected = false;
                    this.$set(this.locations, this.last_selected, changeValue);
                }

                let newValue = this.locations[index];
                newValue.is_selected = true;
                this.$set(this.locations, index, newValue);
                this.can_select = false;
                this.last_selected = index;

                // Make sure only markers that are selected are green
                this.selectedLocations = [];

                for (let location of this.locations) {
                    if (location.is_selected) {
                        const startDateDayAndMonth = this.date.split('tot')[0];

                        const startDay = parseInt(startDateDayAndMonth.split('-')[0]);
                        const startMonth = parseInt(startDateDayAndMonth.split('-')[1]);

                        const startMonthHighSeason = parseInt(this.dates.date_start_month_high_season_rental_mobile_home);
                        const startDayHighSeason = parseInt(this.dates.date_start_day_high_season_rental_mobile_home);

                        const endMonthHighSeason = parseInt(this.dates.date_end_month_high_season_rental_mobile_home);
                        const endDayHighSeason = parseInt(this.dates.date_end_day_high_season_rental_mobile_home);

                        const dateIsInHighSeason =
                            ((startMonth === startMonthHighSeason && startDay >= startDayHighSeason) || (startMonth === endMonthHighSeason && startDay <= endDayHighSeason))
                            ||
                            (startMonth > startMonthHighSeason && startMonth < endMonthHighSeason)

                        // Exception daycount minimum 6 days for rental_mobile_homes in the high season
                        if (location.type === 'rental_mobile_home' && dateIsInHighSeason && this.dayCount < 6) {
                            this.$swal("Let op", 'Verhuurcaravans hebben een minimum van 6 overnachtingen in deze periode. Wijzig de datum periode of selecteer een andere locatie');
                        }

                        else if (location.type === 'accommodation' && dateIsInHighSeason && this.dayCount < 6) {
                            this.$swal("Let op", 'Logies hebben een minimum van 6 overnachtingen in deze periode. Wijzig de datum periode of selecteer een andere locatie');
                        }

                        // Exception daycount minimum 2 for rental_mobile_homes in low season
                        else if (location.type === 'rental_mobile_home' && this.dayCount < 2) {
                            this.$swal("Let op", 'Verhuurcaravans hebben een minimum van 2 overnachtingen. Wijzig de datum periode of selecteer een andere locatie');
                        }

                        // Exception daycount minimum 2 for accommodations
                        else if (location.type === 'accommodation' && this.dayCount < 2) {
                            this.$swal("Let op", 'Logies hebben een minimum van 2 overnachtingen. Wijzig de datum periode of selecteer een andere locatie');
                        }

                        // Exception daycount minimum 2 for pipo_homes
						else if (location.type === 'pipo_home' && this.dayCount < 2) {
                            this.$swal("Let op", 'Pipowagens hebben een minimum van 2 overnachtingen. Wijzig de datum periode of selecteer een andere locatie');
						}

                        else {
							// the marker should be made green
							this.markers[location.index_id].setIcon('frontend/img/maps/marker-' + location.type + '-select.png');
							this.selectedLocations.unshift(location);
						}
                    } else {
                        this.markers[location.index_id].setMap(this.map);
                    }
                }
            },
            makeReservation() {
                if (this.date !== null && this.date.includes('tot')) {
                    // Make sure all cards are closed
                    let liList = document.getElementsByTagName("li");

                    // Array.from(liList).forEach((el) => {
                    //     el.classList.remove('active');
                    // });

                    EventBus.$emit('create-reservation', this.selectedLocations, this.date, this.$refs.datePicker.fp);
                } else {
                    this.$swal("Let op", "Het lijkt erop dat je nog geen boekingsdatum ingevuld hebt. Zorg dat je ten minste twee opeenvolgende dagen kiest.");
                }
            },
            flatDisabledDays(selectedDays, dateStr, instance) {

                // Don't need this anymore, excpetion on logies
                if (this.isAdminUser === false) {
                    for (let child of instance.days.children) {
                        if (child.classList.contains("flatpickr-disabled")) {
                            child.style.backgroundColor = "#ddd";
                            child.style.color = '#ffffff'
                        }
                    }
                }

            }
        },
        mounted() {

        	// Set location date
        	if (this.setLocationDate !== undefined && this.setLocationDate !== null) {
        		this.date = this.setLocationDate;
			}

            // Debug set location date
            if (this.debug === true) {
                this.date = '15-10-2023 tot 20-10-2023';
            }

            let vm = this;
            EventBus.$on('maps-loaded', () => {
                vm.initMap();
            });

            EventBus.$on('reset', (resetDate) => {
                vm.can_select = true;
                vm.last_selected = null;
                vm.selectedLocations = [];

                if (resetDate) {
                    vm.date = null;
                }

                // Make all markers visible again
                for (let location of this.locations) {
                    location.is_selected = false;
                    this.markers[location.index_id].setMap(this.map);
                }
            });

            axios.get('ajax/get-map-data')
                .then(response => {
                    this.notifications = response.data.notifications;
                    this.dates = response.data.dates;

                    this.isAdminUser = response.data.isAdminUser;
                    this.flat_config.minDate = (!this.isAdminUser ? 'today' : false);

                    if (!this.setLocationDate) {
                        this.locations = response.data.locations;

                        for (let i = 0; i < this.locations.length; i++) {
                            let location = this.locations[i];

                            location.is_selected = false;
                            const myLatLng = {lat: parseFloat(location.marker_x), lng: parseFloat(location.marker_y)};
                            let marker = new google.maps.Marker({
                                title: String(i),
                                position: myLatLng,
                                map: this.map,
                                icon: location.marker,
                                label: {
                                    color: '#ffffff',
                                    text: String(location.location_number)
                                }
                            });

                            marker.addListener("click", () => {
                                this.$swal("Let op", "Er moet een datum geselecteerd zijn om een plaats te selecteren.");
                            });
                            this.markers[location.index_id] = marker;
                        }
                    }
                })
                .catch(e => {
                    this.$swal("Oeps!", "Er is iets mis gegaan bij het ophalen van de locaties. Probeer het later nog een keer.", "error");
                });

        }
    }
</script>

<style scoped>
    #map {
        width: 100%;
        height: 500px;
    }

    .warning {
        width: 100%;
        margin-bottom: 20px;
        background-color: rgba(255, 184, 24, 0.75);
        border-radius: 5px;
        color: #ffffff;
        padding: 10px 20px 10px 20px;
    }
    .bold {
        font-weight: bold;
    }
</style>
